import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  SvgIcon,
  CircularProgress,
  styled,
  InputBase,
  Card,
  Dialog,
  Button
} from '@mui/material';
import {
  colorAppBackground,
  colorLinkGrey,
  colorPureWhite,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  getAllContentBySection,
  revertResources
} from '../../redux/reducers/resourcesSlice';
import { useSelector } from 'react-redux';
import { ChevronRightIcon } from '../../utils/iconSvg';
import SnackBarBox from '../../components/SnackBarBox';
import { formatDateTimeAgo, handleError } from '../../utils/utils';
import _ from 'lodash';
import {
  AUDIO_ICON,
  AUDIO_RESOURCE_SMALL_ICON,
  AUDIO_RESOURCES_ICON,
  DOC_RESOURCE_SMALL_ICON,
  DOC_RESOURCES_ICON,
  FLASHCARD_RESOURCE_SMALL_ICON,
  FLASHCARD_RESOURCES_ICON,
  IMAGE_RESOURCE_SMALL_ICON,
  LIKE_ICON,
  LOCK_ICON,
  OpenLinkIcon,
  PDF_RESOURCE_SMALL_ICON,
  PDF_RESOURCES_ICON,
  PPT_RESOURCE_SMALL_ICON,
  PPT_RESOURCES_ICON,
  VIDEO_RESOURCE_SMALL_ICON,
  XLS_RESOURCE_SMALL_ICON,
  XLS_RESOURCES_ICON
} from '../../utils/imageUrls';
import MoreActionsComponent from '../../containers/Resources/MoreActionsComponent';
import { VisibilityOutlined } from '@mui/icons-material';
import ReactPlayer from 'react-player';
import {
  getFreeVideoWatchCount,
  setFreeVideoWatchCount
} from '../../config/cookie';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,

  marginLeft: 0,
  // marginRight: 10,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  // padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  right: 6,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

let searchValue = '';
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  height: '2rem',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1.5),
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: searchValue ? '28ch' : '0px',
    border: searchValue ? '1px solid #CBD2D9' : '',
    borderRadius: searchValue ? '8px' : '',
    [theme.breakpoints.up('sm')]: {
      '&:focus': {
        width: searchValue ? '28ch' : '28ch',
        border: '1px solid #CBD2D9',
        borderRadius: '8px'
      }
    }
  }
}));

const LiteResourcewiseContent = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    sectionWiseContentList,
    isSectionWiseContentLoading,
    isSaveToWatchLaterLoading,
    isSaveToWatchLaterSuccess,
    isSaveToWatchLaterFailed,
    saveToWatchLaterResponse,
    saveToWatchLaterErrorContainer
  } = useSelector(state => state.resource);

  const contentList = sectionWiseContentList?.payload?.dataList || [];
  const [searchTerm, setSearchTerm] = useState('');
  const [isMoreStoriesModalOpen, setIsMoreStoriesModalOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [lockContent, setLockContent] = useState(false);

  const defaultExcelSvg = '/images/default-excel.svg';
  const defaultWordSvg = '/images/default-word.svg';
  const defaultPowerPointSvg = '/images/default-powerpoint.svg';
  const defaultPdfSvg = '/images/default-pdf.svg';

  useEffect(() => {
    dispatch(revertResources());
    if (location?.state?.sectionId) {
      getSectioniWiseData();
    }
  }, [location.state.sectionId, searchTerm]);

  const getSectioniWiseData = () => {
    let payload = {
      page: 0,
      size: 15,
      type: 'all'
    };
    let queryParam = {
      search: searchTerm || '',
      grade: '',
      sectionId: location?.state?.sectionId,
      userId: '',
      encryptedContentId: '',
      tags: location.state.tags || ''
    };
    dispatch(getAllContentBySection({ payload, queryParam }));
  };
  const debouncedSearch = _.debounce(term => setSearchTerm(term), 300);

  const handleSearch = e => {
    const term = e.target.value;
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  // Content Card API

  const getFreeCount = getFreeVideoWatchCount();

  const handleLikeDislike = (e, video) => {
    e.stopPropagation();
    if (video?.content_type !== 'All') {
      setLockContent(true);
      setIsMoreStoriesModalOpen(true);
    } else {
      setIsMoreStoriesModalOpen(true);
    }
  };

  const handleOnClick = content => {
    if (content.upload_type == 'Flashcard') {
      setIsMoreStoriesModalOpen(true);
      return;
    }
    if (getFreeCount > 4) {
      setIsMoreStoriesModalOpen(true);
    } else if (content?.content_type !== 'All') {
      setLockContent(true);
      setIsMoreStoriesModalOpen(true);
    } else {
      let freeCount = getFreeCount;
      let sum = (freeCount || 0) + 1;

      setFreeVideoWatchCount(sum);
      setPreviewData(content);
      setIsPreviewOpen(true);
    }
  };

  const handleOpenModal = () => {
    setIsMoreStoriesModalOpen(true);
  };

  const handleOpenInGoogleDocs = data => {
    if (data?.upload_type === 'PDF' || data?.upload_type === 'Image') {
      window.open(data?.content_file_url, '_blank');
    } else {
      const googleDocsUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(data?.content_file_url)}`;
      window.open(googleDocsUrl, '_blank');
    }
  };

  const handleCloseModal = () => {
    setLockContent(false);
    setIsMoreStoriesModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '12px',
          justifyContent: 'space-between'
        }}
      >
        <div style={{ display: 'flex' }}>
          <Typography
            style={{
              fontSize: '24px',
              fontFamily: 'Lato',
              lineHeight: '32px',
              fontWeight: 700,
              color: colorLinkGrey,
              cursor: 'pointer'
            }}
            onClick={() => navigate('/lite-resources')}
          >
            Home
          </Typography>
          <SvgIcon sx={{ height: 32, width: 32 }}>
            <ChevronRightIcon color={colorTextGrey} />
          </SvgIcon>
          <Typography
            style={{
              fontSize: '32px',
              fontFamily: 'Lato',
              lineHeight: '36px',
              fontWeight: 700,
              color: colorTextBlack
            }}
          >
            {location?.state?.sectionName || ''}
          </Typography>
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: '700',
              color: colorTextBlack,
              marginLeft: '10px',
              marginTop: '5px'
            }}
          >
            {`(${location.state?.subTitle})`}
          </Typography>
        </div>

        <Search>
          <SearchIconWrapper>
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                stroke="#ABB4BD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </SearchIconWrapper>
          <StyledInputBase
            onChange={e => {
              searchValue = e.target.value;
              handleSearch(e);
            }}
            placeholder="Search here…"
          />
        </Search>
      </Box>

      {isSectionWiseContentLoading ? (
        <div
          style={{
            marginTop: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '70vh'
          }}
        >
          <CircularProgress />
        </div>
      ) : !isSectionWiseContentLoading && contentList.length > 0 ? (
        <Box
          sx={{
            marginBottom: 4,
            backgroundColor: '#FFFFFF',
            padding: '16px',
            borderRadius: '8px'
          }}
        >
          <Grid container spacing={2}>
            {contentList &&
              contentList?.map((video, index) => {
                const uploadType = video?.upload_type || video?.uploadType;
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <>
                      {uploadType === 'Video' || uploadType === 'Image' ? (
                        <Card
                          sx={{
                            boxShadow: 'none',
                            border: '1px solid #CBD2D9',
                            cursor: 'pointer',
                            backgroundColor: colorAppBackground,
                            padding: '12px',
                            height: '100%',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            borderRadius: '8px'
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginBottom: '5px',
                              alignItems: 'center'
                            }}
                            onClick={() => handleOnClick(video)}
                          >
                            <Box marginBottom={1}>
                              <img
                                src={
                                  video?.upload_type === 'Image'
                                    ? IMAGE_RESOURCE_SMALL_ICON
                                    : video?.upload_type === 'Video'
                                      ? VIDEO_RESOURCE_SMALL_ICON
                                      : PPT_RESOURCE_SMALL_ICON
                                }
                                alt="thumbnail"
                                style={{
                                  width: '100%',
                                  height: 'auto',
                                  objectFit: 'contain',
                                  maxWidth: '100%',
                                  display: 'block'
                                }}
                              />
                            </Box>

                            <div
                              style={{
                                width: '26px',
                                height: '26px',
                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                borderRadius: '50%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: video?.likes ? 'pointer' : 'not-allowed'
                              }}
                              onClick={e => handleLikeDislike(e, video)}
                            >
                              <img
                                className="imgbox"
                                src={
                                  video?.content_type !== 'All'
                                    ? LOCK_ICON
                                    : LIKE_ICON
                                }
                                alt="Like Icon"
                                width={15}
                                height={15}
                                style={{
                                  cursor: video?.likes
                                    ? 'pointer'
                                    : 'not-allowed'
                                }}
                              />
                            </div>
                          </div>

                          <div
                            style={{
                              position: 'relative',
                              width: '100%',
                              height: '121px'
                            }}
                          >
                            <img
                              src={
                                video?.thumbnail_file_url ||
                                'https://afx-data.s3.ap-south-1.amazonaws.com/PAF_20250326171015_20mb.jpg'
                              }
                              alt="PDF thumbnail"
                              style={{
                                width: '100%',
                                height: '121px',
                                objectFit: 'fill',
                                borderRadius: '8px'
                              }}
                              onClick={() => handleOnClick(video)}
                            />

                            {/* Duration Overlay */}
                            {uploadType === 'Video' && (
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: '5px',
                                  right: '5px',
                                  backgroundColor: colorTextBlack,
                                  borderRadius: '5px',
                                  padding: '5px'
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    fontFamily: 'Lato',
                                    color: colorPureWhite
                                  }}
                                >
                                  {video?.duration || '00:00'}
                                </Typography>
                              </div>
                            )}
                          </div>

                          <div style={{ marginTop: '0.5rem' }}>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start'
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 700,
                                  fontFamily: 'Lato',
                                  fontSize: '16px',
                                  display: 'inline-block',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  lineHeight: '20px'
                                }}
                                onClick={() => handleOnClick(video)}
                              >
                                {video.title}
                              </Typography>

                              <div style={{ marginLeft: '10px' }}>
                                <MoreActionsComponent data={video} />
                              </div>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#ABB4BD',
                                gap: 1,
                                fontWeight: 500,
                                fontFamily: 'Lato',
                                fontSize: '14px',
                                lineHeight: '18px',
                                marginTop: '10px'
                              }}
                              onClick={() => handleOnClick(video)}
                            >
                              <VisibilityOutlined fontSize="small" />
                              <Typography
                                style={{
                                  fontSize: '14px',
                                  fontFamily: 'Lato',
                                  lineHeight: '18px',
                                  fontWeight: 500,
                                  color: colorTextGrey
                                }}
                              >
                                {video.views}
                              </Typography>

                              <Typography
                                style={{
                                  fontSize: '14px',
                                  fontFamily: 'Lato',
                                  lineHeight: '18px',
                                  fontWeight: 500,
                                  color: colorTextGrey
                                }}
                              >
                                •
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: '14px',
                                  fontFamily: 'Lato',
                                  lineHeight: '18px',
                                  fontWeight: 500,
                                  color: colorTextGrey
                                }}
                              >
                                {video.updated_dt
                                  ? formatDateTimeAgo(video.updated_dt)
                                  : '-'}
                              </Typography>
                            </Box>
                          </div>
                        </Card>
                      ) : uploadType === 'POWERPOINT' ||
                        uploadType === 'MSWORD' ||
                        uploadType === 'EXCEL' ||
                        uploadType === 'PDF' ||
                        uploadType === 'Flashcard' ? (
                        <>
                          <Card
                            sx={{
                              boxShadow: 'none',
                              border: '1px solid #CBD2D9',
                              cursor: 'pointer',
                              backgroundColor: colorAppBackground,
                              padding: '12px',
                              height: '100%',
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              borderRadius: '8px'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '5px',
                                alignItems: 'center'
                              }}
                              onClick={() => handleOnClick(video)}
                            >
                              <Box marginBottom={1}>
                                <img
                                  src={
                                    video?.upload_type === 'POWERPOINT'
                                      ? PPT_RESOURCE_SMALL_ICON
                                      : video?.upload_type === 'MSWORD'
                                        ? DOC_RESOURCE_SMALL_ICON
                                        : video?.upload_type === 'EXCEL'
                                          ? XLS_RESOURCE_SMALL_ICON
                                          : video?.upload_type === 'PDF'
                                            ? PDF_RESOURCE_SMALL_ICON
                                            : video?.upload_type === 'Flashcard'
                                              ? FLASHCARD_RESOURCE_SMALL_ICON
                                              : PPT_RESOURCE_SMALL_ICON
                                  }
                                  alt="Audio thumbnail"
                                  style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    maxWidth: '100%',
                                    display: 'block'
                                  }}
                                />
                              </Box>

                              <div
                                style={{
                                  width: '26px',
                                  height: '26px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '50%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  cursor: video?.likes
                                    ? 'pointer'
                                    : 'not-allowed'
                                }}
                                onClick={e => handleLikeDislike(e, video)}
                              >
                                <img
                                  className="imgbox"
                                  src={
                                    video?.content_type !== 'All'
                                      ? LOCK_ICON
                                      : LIKE_ICON
                                  }
                                  alt="Like Icon"
                                  width={15}
                                  height={15}
                                  style={{
                                    cursor: video?.likes
                                      ? 'pointer'
                                      : 'not-allowed'
                                  }}
                                />
                              </div>
                            </div>

                            <img
                              src={
                                video?.thumbnail_file_url ||
                                'https://afx-data.s3.ap-south-1.amazonaws.com/PAF_20250326171015_20mb.jpg'
                              }
                              alt="PDF thumbnail"
                              style={{
                                width: '100%',
                                height: '121px',
                                objectFit: 'fill',
                                borderRadius: '8px'
                              }}
                              onClick={() => handleOnClick(video)}
                            />

                            <div style={{ marginTop: '0.5rem' }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'flex-start'
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: 700,
                                    fontFamily: 'Lato',
                                    fontSize: '16px',
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    lineHeight: '20px'
                                  }}
                                  onClick={() => handleOnClick(video)}
                                >
                                  {video.title}
                                </Typography>

                                <div style={{ marginLeft: '10px' }}>
                                  <MoreActionsComponent
                                    data={video}
                                    isDisabled={true}
                                    handleOpenModal={handleOpenModal}
                                  />
                                </div>
                              </Box>

                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#ABB4BD',
                                  gap: 1,
                                  fontWeight: 500,
                                  fontFamily: 'Lato',
                                  fontSize: '14px',
                                  lineHeight: '18px',
                                  marginTop: '10px'
                                }}
                                onClick={() => handleOnClick(video)}
                              >
                                <VisibilityOutlined fontSize="small" />
                                <Typography
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: 'Lato',
                                    lineHeight: '18px',
                                    fontWeight: 500,
                                    color: colorTextGrey
                                  }}
                                >
                                  {video.views}
                                </Typography>

                                <Typography
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: 'Lato',
                                    lineHeight: '18px',
                                    fontWeight: 500,
                                    color: colorTextGrey
                                  }}
                                >
                                  •
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: 'Lato',
                                    lineHeight: '18px',
                                    fontWeight: 500,
                                    color: colorTextGrey
                                  }}
                                >
                                  {video.updated_dt
                                    ? formatDateTimeAgo(video.updated_dt)
                                    : '-'}
                                </Typography>
                              </Box>
                            </div>
                          </Card>
                        </>
                      ) : uploadType === 'Audio' ? (
                        <>
                          <Card
                            sx={{
                              boxShadow: 'none',
                              position: 'relative',
                              border: '1px solid #CBD2D9',
                              cursor: 'pointer',
                              backgroundColor: colorAppBackground,
                              padding: '12px',
                              height: '100%',
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              borderRadius: '8px'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '5px',
                                alignItems: 'center'
                              }}
                              onClick={() => handleOnClick(video)}
                            >
                              <Box marginBottom={1}>
                                <img
                                  src={AUDIO_RESOURCE_SMALL_ICON}
                                  alt="Audio thumbnail"
                                  style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    maxWidth: '100%',
                                    display: 'block'
                                  }}
                                />
                              </Box>

                              <div
                                style={{
                                  width: '26px',
                                  height: '26px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  borderRadius: '50%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  cursor: video?.likes
                                    ? 'pointer'
                                    : 'not-allowed'
                                }}
                                onClick={e => handleLikeDislike(e, video)}
                              >
                                <img
                                  className="imgbox"
                                  src={
                                    video?.content_type !== 'All'
                                      ? LOCK_ICON
                                      : LIKE_ICON
                                  }
                                  alt="Like Icon"
                                  width={15}
                                  height={15}
                                  style={{
                                    cursor: video?.likes
                                      ? 'pointer'
                                      : 'not-allowed'
                                  }}
                                />
                              </div>
                            </div>

                            <img
                              src={
                                video?.thumbnail_file_url ||
                                'https://afx-data.s3.ap-south-1.amazonaws.com/PAF_20250326171015_20mb.jpg'
                              }
                              alt="Audio thumbnail"
                              style={{
                                width: '100%',
                                height: '121px',
                                objectFit: 'fill',
                                borderRadius: '8px'
                              }}
                              onClick={() => handleOnClick(video)}
                            />

                            <div style={{ marginTop: '1rem' }}>
                              {/* Title with Menu Icon */}
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'flex-start'
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: 700,
                                    fontFamily: 'Lato',
                                    fontSize: '16px',
                                    display: 'inline-block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    lineHeight: '20px'
                                  }}
                                  onClick={() => handleOnClick(video)}
                                >
                                  {video.title}
                                </Typography>

                                <div style={{ marginLeft: '10px' }}>
                                  <MoreActionsComponent
                                    data={video}
                                    isDisabled={true}
                                    handleOpenModal={handleOpenModal}
                                  />
                                </div>
                              </Box>

                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#ABB4BD',
                                  gap: 1,
                                  fontWeight: 500,
                                  fontFamily: 'Lato',
                                  fontSize: '14px',
                                  lineHeight: '18px',
                                  marginTop: '10px'
                                }}
                                onClick={() => handleOnClick(video)}
                              >
                                <VisibilityOutlined fontSize="small" />
                                <Typography
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: 'Lato',
                                    lineHeight: '18px',
                                    fontWeight: 500,
                                    color: colorTextGrey
                                  }}
                                >
                                  {video.views}
                                </Typography>

                                <Typography
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: 'Lato',
                                    lineHeight: '18px',
                                    fontWeight: 500,
                                    color: colorTextGrey
                                  }}
                                >
                                  •
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: 'Lato',
                                    lineHeight: '18px',
                                    fontWeight: 500,
                                    color: colorTextGrey
                                  }}
                                >
                                  {video.updated_dt
                                    ? formatDateTimeAgo(video.updated_dt)
                                    : '-'}
                                </Typography>
                              </Box>
                            </div>
                          </Card>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  </Grid>
                );
              })}
          </Grid>
        </Box>
      ) : !isSectionWiseContentLoading && contentList.length == 0 ? (
        <Box
          sx={{
            marginBottom: 4,
            backgroundColor: '#FFFFFF',
            padding: '16px',
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Typography
            style={{
              fontFamily: 'Lato',
              fontSize: '14px',
              fontWeight: 700,
              color: colorTextGrey
            }}
          >
            {' '}
            No content available
          </Typography>
        </Box>
      ) : (
        <> </>
      )}

      {/* Register Pop Up Modal */}

      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '8px'
          }
        }}
        open={isMoreStoriesModalOpen}
        onClose={handleCloseModal}
      >
        <Box
          sx={{
            width: '529px',
            padding: '40px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          {lockContent ? (
            <>
              <Typography
                fontSize={'20px'}
                fontWeight={700}
                lineHeight={'26px'}
                fontFamily={'Lato'}
                color={colorLinkGrey}
                textAlign={'center'}
              >
                Uh-Oh!
              </Typography>
              <Typography
                fontSize={'20px'}
                fontWeight={700}
                lineHeight={'26px'}
                fontFamily={'Lato'}
                color={colorLinkGrey}
                textAlign={'center'}
              >
                This content is locked!
              </Typography>
              <Typography
                fontSize={'20px'}
                fontWeight={700}
                lineHeight={'26px'}
                fontFamily={'Lato'}
                color={colorLinkGrey}
                textAlign={'center'}
              >
                Register now to unlock!
              </Typography>
            </>
          ) : (
            <Typography
              fontSize={'20px'}
              fontWeight={700}
              lineHeight={'26px'}
              fontFamily={'Lato'}
              color={colorLinkGrey}
              textAlign={'center'}
            >
              More stories, more exam prep, and more content for teaching and
              learning.
            </Typography>
          )}

          <Button
            sx={{
              width: '146px',
              height: '42px',
              boxShadow: 'none',
              fontWeight: '700',
              fontSize: '14px',
              marginTop: '25px'
            }}
            variant="contained"
            onClick={() => navigate('/sign-up')}
          >
            Register now
          </Button>
        </Box>
      </Dialog>

      {/* Preview Modal */}

      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px'
          },
          '& .MuiDialog-paperWidthSm': {
            maxWidth: '702px'
          }
        }}
        open={isPreviewOpen}
        onClose={() => {
          setIsPreviewOpen(false);
          setPreviewData([]);
        }}
      >
        {/* <Grid sx={{ padding: '24px' }}> */}
        <Card
          sx={{
            boxShadow: 'none',
            border: 'none',
            padding: '24px'
          }}
        >
          <Box
            sx={{
              width: '622px',
              height: '363px',
              backgroundColor: '#fff',
              overflow: 'hidden',
              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '100%',
                borderRadius: '12px',
                overflow: 'hidden',
                position: previewData?.upload_type === 'Audio' && 'relative'
              }}
            >
              {previewData?.upload_type === 'Video' ||
              previewData?.upload_type === 'Audio' ? (
                <>
                  <ReactPlayer
                    url={previewData?.content_file_url || ''}
                    playing={true}
                    controls={true}
                    width="100%"
                    style={{ borderRadius: '12px' }}
                    config={{
                      file: {
                        attributes: {
                          controlsList: 'nodownload' // Disable download option
                        }
                      }
                    }}
                  />
                  {previewData?.upload_type === 'Audio' && (
                    <div
                      style={{
                        position: 'absolute',
                        zIndex: '10',
                        bottom: '70px',
                        width: '100%',
                        height: '80%'
                      }}
                    >
                      <img
                        src={AUDIO_ICON}
                        alt="Audio"
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      borderRadius: '12px'
                    }}
                  >
                    <img
                      src={
                        previewData?.upload_type === 'POWERPOINT'
                          ? defaultPowerPointSvg
                          : previewData?.upload_type === 'MSWORD'
                            ? defaultWordSvg
                            : previewData?.upload_type === 'EXCEL'
                              ? defaultExcelSvg
                              : previewData?.upload_type === 'PDF'
                                ? defaultPdfSvg
                                : previewData?.upload_type === 'Image'
                                  ? previewData?.content_file_url
                                  : defaultExcelSvg
                      }
                      alt="Audio"
                      style={{
                        width: '100%',
                        height: '350px',
                        borderRadius: '12px'
                      }}
                    />

                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: `${previewData?.upload_type !== 'Image' ? 'rgba(128, 128, 128, 0.5)' : ''}`,
                        borderRadius: '12px'
                      }}
                    />

                    <div
                      style={{
                        position: 'absolute',
                        bottom: 15,
                        left: 15,
                        backgroundColor: '#FFFFFF',
                        borderRadius: '8px',
                        padding: '12px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleOpenInGoogleDocs(previewData)}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: '14px',
                            lineHeight: '18px',
                            fontWeight: 700,
                            fontFamily: 'Lato',
                            color: colorTextBlack,
                            marginRight: '5px'
                          }}
                        >
                          {' '}
                          Open Link{' '}
                        </Typography>

                        <OpenLinkIcon />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Box>

          <div style={{ marginTop: '10px' }}>
            <Typography
              style={{
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: '32px',
                fontFamily: 'Lato',
                color: colorTextBlack,
                marginBottom: '8px'
              }}
            >
              {previewData?.title || ''}
            </Typography>
            <Typography
              fontWeight={'700'}
              size={'24px'}
              color={colorTextBlack}
              marginBottom={'8px'}
            >
              {previewData?.created_by || ''}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#ABB4BD',
                gap: 1,
                fontWeight: 500,
                fontFamily: 'Lato',
                fontSize: '14px',
                lineHeight: '18px'
              }}
            >
              <VisibilityOutlined fontSize="small" />
              <Typography
                style={{
                  fontSize: '14px',
                  fontFamily: 'Lato',
                  lineHeight: '18px',
                  fontWeight: 500,
                  color: colorTextGrey
                }}
              >
                {previewData?.views || 0}
              </Typography>

              <Typography
                style={{
                  fontSize: '14px',
                  fontFamily: 'Lato',
                  lineHeight: '18px',
                  fontWeight: 500,
                  color: colorTextGrey
                }}
              >
                •
              </Typography>
              <Typography
                style={{
                  fontSize: '14px',
                  fontFamily: 'Lato',
                  lineHeight: '18px',
                  fontWeight: 500,
                  color: colorTextGrey
                }}
              >
                {previewData?.updated_dt
                  ? formatDateTimeAgo(previewData?.updated_dt)
                  : '-'}
              </Typography>
            </Box>
          </div>
        </Card>
        {/* </Grid> */}
      </Dialog>

      {!isSaveToWatchLaterLoading &&
        isSaveToWatchLaterSuccess &&
        saveToWatchLaterResponse && (
          <SnackBarBox
            type="success"
            message={handleError(saveToWatchLaterResponse?.payload?.message)}
          />
        )}

      {!isSaveToWatchLaterLoading &&
        saveToWatchLaterErrorContainer &&
        isSaveToWatchLaterFailed && (
          <SnackBarBox
            type="error"
            message={handleError(saveToWatchLaterErrorContainer?.errorMessage)}
          />
        )}
    </>
  );
};

export default LiteResourcewiseContent;
